module.exports = __webpack_public_path__ + "img/bgTop.250ec9c1.png";